export default __webpack_public_path__ + "static/media/enquiry-title-icon.f03d698a.svg";